<template>
  <router-view />
</template>

<script>
export default {
  name: 'Course',
  data() {
    return {}
  },
}
</script>
